// eslint-disable-next-line import/prefer-default-export
export const okendoReviewsJsonLD = (okendoReviews) => {

    const { reviews, reviewAggregate } = okendoReviews;

    const averageRating = ({ reviewRatingValuesTotal = 0 , reviewCount = 0 }) => (
        Math.round(10 * (reviewRatingValuesTotal / reviewCount)) / 10
    )

    const review = reviews?.[0];
    const aggregate = reviewAggregate || {}
    const ratingValue = averageRating(aggregate)

    const jsonLd = {
        "@context": "http://schema.org/",
        "@type": "Product",
        "name": `${review?.productName}`,
        "image": `${review?.productImageUrl}`,
        "mpn": `${review?.productId?.replace('shopify-', "")}`,
        "description": `${review?.body}`,
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": `${Number.isNaN(ratingValue) ? 0 : ratingValue}`,
            "ratingCount": `${reviewAggregate?.reviewCount || 0}`
        }
    }

    const jsonLdFormat = Object.keys(jsonLd).reduce((obj, key) => {
        const data = jsonLd[key] ? { [key]: jsonLd[key] } : {}
        return { ...obj, ...data };
    }, {});

    return JSON.stringify(jsonLdFormat)
}